import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid, Button } from "@material-ui/core";
import {
  TextField,
  FormControl,
  Stack,
  Snackbar,
  Alert,
  LinearProgress,
  Radio,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { MetaTags } from "react-meta-tags";
import axios from "axios";
import Cookies from "js-cookie";
//import Tooltip from '@mui/material/Tooltip';
import QuestionMCSave from "./QuestionMCSave";
import QuestionMRSave from "./QuestionMRSave";
import QuestionFIBSave from "./QuestionFIBSave";
import QuestionCDSave from "./QuestionCDSave";
import QuestionMRMTSave from "./QuestionMRMTSave";
import QuestionMCMTSave from "./QuestionMCMTSave";
import DialogAuthorization from "../components/DialogAuthorization";
// import { useSelector } from "react-redux";
import * as env from "../utils/EnvVars";
import Header from "../pages/HeaderMy";
import "../styles/bizofficer-a.css";
import "font-awesome/css/font-awesome.min.css";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CombinedPreview from "./CombinedPreview";
import DeleteIcon from "@mui/icons-material/Delete";
import QuestionTF from "./QuestionTF";

var vertical = "top",
  horizontal = "center";

export default function Execute() {
  // const userObj = useSelector((state) => state.userDetails);
  const isloggedin = Cookies.get("isadminloggedin");
  const childRefMCSave = React.useRef();
  const childRefMRSave = React.useRef();
  const childRefFIBSave = React.useRef();
  const childRefCDSave = React.useRef();
  const childRefMRMTSave = React.useRef();
  const childRefMCMTSave = React.useRef();
  const childRefTF = React.useRef();
  const childRefAuthorization = React.useRef();
  const childRefInfo = React.useRef();
  const [pageLoading, setPageLoading] = React.useState(true);
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  const [filter, setFilter] = React.useState(false);
  const [keyword, setKeyword] = React.useState("");
  const [dataObj, setDataObj] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(0);

  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [privileges, setPrivileges] = React.useState("");
  const [rowData, setRowData] = useState([]);

  var myCurrentDate = new Date();
  var myPastFromDate = new Date(myCurrentDate);
  myPastFromDate.setDate(myPastFromDate.getDate() - 366);

  function hideAlert() {
    setShowAlert(false);
  }

  const columns = [
    {
      field: "Select",
      headerName: "",
      width: 90,
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Radio
            checked={cellValues.id === selectedRow}
            onChange={() => selectRow(cellValues.row)}
            value={cellValues.id}
            name="radio-buttons"
            inputProps={{ "aria-label": { cellValues } }}
          />
        );
      },
    },
    { field: "id", headerName: "Sr. No.", width: 40 },
    { field: "topicName", headerName: "Topic Name", width: 200 },
    { field: "questionType", headerName: "Question Type", width: 200 },
    { field: "gradeName", headerName: "Grade", width: 200 },
    { field: "difficultyName", headerName: "Difficulty", width: 200 },
    { field: "examType", headerName: "Exam Type", width: 200 },
    { field: "language", headerName: "Language", width: 200 },
    { field: "country", headerName: "Country", width: 200 },
    { field: "tags", headerName: "Tags", width: 200 },
    { field: "modifiedDateTime", headerName: "Modified Date/Time", width: 200 },
    { field: "modifiedBy", headerName: "Modified By", width: 200 },
  ];

  // check if logged in
  // React.useEffect(() => {
  // 	if(!isloggedin){
  // 		window.location.href='login';
  // 	}
  // }, [isloggedin]);

  React.useEffect(() => {
    //if(userObj.loginId && userObj.token){
    // getApiData();
    //}
    getData();
  }, [
    // userObj,
    // filter,
    rows,
  ]);

  async function getApiData() {
    setPageLoading(true);
    ///alert(userObj.token);
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: "testing",
        token: "asdfasdfasdfasfd",
        device: "web",
      },
    };

    axios
      .get(
        env.API_URL + "/app/admin-questionbanks-list?keyword=" + keyword,
        axiosHeader
      )
      .then((response) => {
        // alert("status >> "+response.status);
        // alert("Just Checking >> "+JSON.stringify(response));
        setPageLoading(false);
        console.log(response, "responseee");
        ///alert(JSON.stringify(response.data));
        if (response.data && response.data.responseTxt === "invalidToken") {
          Cookies.remove("isadminloggedin");
          window.location.href = "login";
        } else if (
          response.data &&
          response.data.responseTxt === "NoAuthorization"
        ) {
          childRefAuthorization.current.handleClickOpen();
        } else if (response.data && response.data.responseTxt === "success") {
          // setRows(response.data.obj);
          ///setPrivileges(response.data.privileges);
        }
      });
    // .catch((error) => {
    // 	alert("ERROR: ", error);
    // })
  }

  // console.log(dataObj.autoId,"dataObj")

  const getData = async () => {
    setPageLoading(true);
    try {
      const endPoint = env.API_KEY + "/admin-questionbanks-list";
      const res = await axios.get(endPoint);
      if (res?.data?.responseTxt === "success") {
        setPageLoading(false);
        setRowData(res?.data?.obj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function deleteData() {
    if (
      dataObj.id != null
      // && userObj.loginId && userObj.token
    ) {
      let axiosHeader = {
        headers: {
          "Content-Type": "application/json",
          // loginId: userObj.loginId,
          // token: userObj.token,
          // device: "web",
        },
      };

      const data = new FormData();
      data.append("id", Number(dataObj.autoId));
      axios
        .post(env.API_KEY + "/admin-questionbanks-delete", data, axiosHeader)
        .then((response) => {
          updatedList(true);
          ///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            deleteDialogHide();
            setSeverityAlert("success");
            setShowAlert(true);
            setAlertMessage("Exam template has been deleted.");
            // setRows(response.data.list);
            // window.location.reload();
            return false;
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("Exam template could not be deleted.");
            return false;
          }
        })
        .catch((error) => {
          console.log("ERROR: ", error);
        });
    }
  }

  function add(opt) {
    console.log(opt, "opt");
    if (
      opt === 1 ||
      opt === 2 ||
      opt === 3 ||
      opt === 5 ||
      opt === 6 ||
      opt === "mc"
    ) {
      // opt === "mc" && setDataObj(null);
      if (opt === "mc") {
        setDataObj(null);
        // setSelectedRow([])
      }
      childRefMCSave.current.handleClickOpen();
    } else if (opt === "mr" || opt === 7) {
      opt === "mr" && setDataObj(null);
      childRefMRSave.current.handleClickOpen();
    } else if (opt === "fib" || opt === 12) {
      opt === "fib" && setDataObj(null);
      childRefFIBSave.current.handleClickOpen();
    } else if (opt === "cd" || opt === 10 || opt === 9) {
      opt === "cd" && setDataObj(null);
      childRefCDSave.current.handleClickOpen();
    } else if (opt === "mrmt" || opt === 8) {
      opt === "mrmt" && setDataObj(null);
      childRefMRMTSave.current.handleClickOpen();
    } else if (opt === "mcmt" || opt === 4) {
      opt === "mcmt" && setDataObj(null);
      childRefMCMTSave.current.handleClickOpen();
    } else if (opt === "info") {
      childRefInfo.current.handleClickOpen();
    } else if (opt === "tf" || opt === 11) {
      opt === "tf" && setDataObj(null);
      childRefTF.current.handleClickOpen();
    }
  }

  // function selectRow(obj) {
  //   // console.log("Selected row:", obj);
  //   if (obj && rows[obj.id - 1]) {
  //     setSelectedRow(rows[obj.id - 1].id);
  //     setDataObj(rows[obj.id - 1]);
  //     ///childRef.current.handleClickOpen();
  //   }
  // }
  function selectRow(obj) {
    // console.log("Selected row:", obj);
    if (obj && rowData[obj.id - 1]) {
      setSelectedRow(rowData[obj.id - 1].id);
      setDataObj(rowData[obj.id - 1]);
      // childRef.current.handleClickOpen();
    }
  }

  function handleRowSelection(selection) {
    setSelectedRow(selection[0] || null);
  }

  function search() {
    setFilter(!filter);
  }

  function onEnter(event) {
    if (event.key === "Enter") {
      search();
    }
  }

  function deleteDialogHide() {
    setDeleteDialogShow(false);
  }

  function updatedList(list) {
    console.log(list, "listttttt");
    setRows(list);
  }

  console.log(dataObj, "dataObj");

  return (
    <div>
      <MetaTags>
        <title>Questions</title>
      </MetaTags>

      <Header title="Questions" />
      {pageLoading ? <LinearProgress /> : null}

      <Box className="mainBox">
        <Box mt={1} mb={1}>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Box display={"flex"}>
                <div>
                  <FormControl
                    style={{ float: "left", width: 150, marginRight: 60 }}
                  >
                    <TextField
                      id="keywordtxt"
                      label="Search"
                      defaultValue={keyword}
                      sx={{ width: 200 }}
                      size="small"
                      onChange={(event) => setKeyword(event.target.value)}
                      onKeyPress={(event) => {
                        onEnter(event);
                      }}
                    />
                  </FormControl>
                  <Button
                    onClick={() => {
                      search();
                    }}
                    style={{ float: "left", marginTop: 3 }}
                    size="small"
                    variant="contained"
                    color="secondary"
                  >
                    Search
                  </Button>

                  {selectedRow && (
                    <>
                      <InfoOutlinedIcon
                        onClick={() => {
                          add("info");
                        }}
                        style={{
                          marginTop: "7px",
                          marginLeft: "10px",
                          color: "#0158dc",
                        }}
                      />
                    </>
                  )}

                  <div style={{ float: "left", marginTop: 4 }}>
                    {/* {(privileges && privileges.length>0 && privileges.indexOf("create")>-1)?<> */}

                    <Button
                      onClick={() => {
                        add("mc");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Multiple Choice"
                    >
                      MC
                    </Button>
                    <Button
                      onClick={() => {
                        add("mr");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Multiple Response"
                    >
                      MR
                    </Button>
                    <Button
                      onClick={() => {
                        add("mrmt");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Multiple Response Matching Type"
                    >
                      MRMT
                    </Button>
                    <Button
                      onClick={() => {
                        add("mcmt");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Multiple Choice Matching Type"
                    >
                      MCMT
                    </Button>
                    <Button
                      onClick={() => {
                        add("fib");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Fill in Blank"
                    >
                      FIB
                    </Button>
                    <Button
                      onClick={() => {
                        add("cd");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="Common Data"
                    >
                      CD
                    </Button>
                    <Button
                      onClick={() => {
                        add("tf");
                      }}
                      style={{ marginLeft: 12 }}
                      size="small"
                      variant="outlined"
                      title="TrueFalse"
                    >
                      T/F
                    </Button>

                    {/* </>:null} 										 */}
                  </div>
                </div>
                <div style={{ float: "left", marginTop: 4 }}>
                  {selectedRow > 0 ? (
                    <>
                      {/* {privileges &&
                    privileges.length > 0 &&
                    privileges.indexOf("update") > -1 ? */}
                      {/* ( */}
                      <>
                        <i
                          onClick={() => {
                            add(dataObj?.questionTypeId);
                          }}
                          title="Edit"
                          className="fa fa-pencil-square-o"
                          style={{
                            fontSize: 25,
                            color: "#0158dc",
                            marginLeft: 15,
                            cursor: "pointer",
                          }}
                        />
                      </>
                      {/* ) : null} */}
                      {/* {privileges &&
                    privileges.length > 0 &&
                    privileges.indexOf("delete") > -1 ? */}
                      {/* ( */}
                      <i
                        onClick={() => {
                          setDeleteDialogShow(true);
                        }}
                        title="Delete"
                        className="fa fa-trash"
                        style={{
                          fontSize: 25,
                          color: "#0158dc",
                          marginLeft: 15,
                          cursor: "pointer",
                        }}
                      />
                      {/* ) : null} */}
                    </>
                  ) : null}
                </div>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <div className="tblReport" style={{ height: "78vh", width: "100%" }}>
          <DataGrid
            rows={rowData}
            columns={columns}
            pageSize={50}
            rowHeight={40}
            rowsPerPageOptions={[50]}
            style={{ fontSize: 12 }}
            components={{
              NoRowsOverlay: () => (
                <Stack height="30%" alignItems="center" justifyContent="center">
                  <span style={{ color: "#FF0000", fontWeight: "bold" }}>
                    No data found!
                  </span>
                </Stack>
              ),
            }}
            onSelectionModelChange={handleRowSelection}
            selectionModel={selectedRow !== null ? [selectedRow] : []}
            onRowClick={(itm) => selectRow(itm)}
          />
        </div>
      </Box>
      <CombinedPreview dataObj={dataObj} ref={childRefInfo} />

      <QuestionMCSave
        dataObj={dataObj}
        ref={childRefMCSave}
        updatedList={updatedList}
      />
      <QuestionMRSave
        dataObj={dataObj}
        ref={childRefMRSave}
        updatedList={updatedList}
      />
      <QuestionFIBSave
        dataObj={dataObj}
        ref={childRefFIBSave}
        updatedList={updatedList}
      />
      <QuestionCDSave
        dataObj={dataObj}
        ref={childRefCDSave}
        updatedList={updatedList}
      />
      <QuestionMRMTSave
        dataObj={dataObj}
        ref={childRefMRMTSave}
        updatedList={updatedList}
      />
      <QuestionMCMTSave
        dataObj={dataObj}
        ref={childRefMCMTSave}
        updatedList={updatedList}
      />
      <QuestionTF
        dataObj={dataObj}
        ref={childRefTF}
        updatedList={updatedList}
      />

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>

      <Dialog
        open={deleteDialogShow}
        onClose={deleteDialogHide}
        aria-labelledby="alert-dialog-section-title"
        aria-describedby="alert-dialog-section-description"
      >
        <DialogTitle id="alert-dialog-section-title">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-section-description">
            Are you sure, You want to delete template name.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              deleteDialogHide();
            }}
          >
            Don't Delete
          </Button>
          <Button
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => {
              deleteData();
            }}
            autoFocus
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>

      <DialogAuthorization ref={childRefAuthorization} />
    </div>
  );
}
